import ModalBox from "components/modal/ModalBox";
import NotFound from "components/not-found/NotFound";
import Switch from "components/Switch/Switch";
import useDebounce from "hooks/useDebounce";
import useFullPageLoader from "hooks/useFullPageLoader";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import Pagination from "react-js-pagination";
import { useSearchParams } from "react-router-dom";
import { dateFormat } from "utils";
import EditIcon from "@mui/icons-material/Edit";
import { Button } from "components/Button/Button";

import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import Tooltip from "components/Tooltip/Tooltip";
import { getCenters, updateCenterStatus } from "services/centers";
import { Table } from "react-bootstrap";
import IconButton from "components/Button/IconButton";
import { useAdminAuth } from "context/context";
import { addBlogcategory, getBlogCategoriesList, getParentBlocks, StatusUpdateBlogcategory, UpdateBlogcategory } from "services/blogs/blogs";

const BlogCategory = () => {
  const [searchParam, setSearchParam] = useSearchParams();
  let activePage = +searchParam.get("page") || 1;

  const [record, setRecord] = useState([]);
  const [parentblockarray, setparentblockarray] = useState([]);
  const [total, setTotal] = useState(0);

  const { roles } = useAdminAuth();

  const [assignStatus, setAssignStatus] = useState({
    course: false,
    faq: false,
    video: false,
    image: false,
  });

  const [galleryImage, setGalleryImage] = useState([]);

  const [blockModal, setBlockModal] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [linkModal, setLinkModal] = useState(false);
  const [linkSelectedId, setLinkSelectedId] = useState("");

  const [addModal, setAddModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();

  const [search, setSearch] = useState(searchParam.get("query") || "");
  const debounceValue = useDebounce(search || "", 300);

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    parentcategoryid: "",
  });

  const [parentCategoryList, setParentCategoryList] = useState([]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear the specific error as user types
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };



  //**********centre Listing**********/
  const blockcategories = async (page = activePage, search = debounceValue) => {
    try {
      showLoader();
      const res = await getBlogCategoriesList({
        page,
        search,
      });
      hideLoader();
      if (res.code === 200) {
        const { rows, count } = res.data.blogCategories;
        setRecord(rows || []);
        setTotal(count || 0);
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
  };
  const parentblocks = async (search = debounceValue) => {
    try {
      showLoader();
      const res = await getParentBlocks({
        search,
      });
      hideLoader();
      if (res.code === 200) {
        setparentblockarray(res.data.parentblocks);
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
  };

  // update status function
  const updateStatusHandler = async () => {
    if (selectedId) {
      try {
        setSubmitLoading(true);
        const res = await StatusUpdateBlogcategory({
          categoryid: selectedId,
          status: selectedStatus ? 0 : 1,
        });
        if (res.code === 200) {
          blockcategories();
          toast.success(res.message);
          setBlockModal(false);
          setSubmitLoading(false);
        } else {
          toast.error(res.message);
          setSubmitLoading(false);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message);
        setSubmitLoading(false);
      }
    }
  };
  const [errors, setErrors] = useState({
    title: '',
    description: '',
  });


  const handleValid = () => {
    let validationErrors = {};
    let isValid = true;

    if (!formData.title) {
      validationErrors.title = 'Title is required';
      isValid = false;
    }

    if (!formData.description) {
      validationErrors.description = 'Description is required';
      isValid = false;
    }

    setErrors(validationErrors);
    return isValid;
  };



  const handleSubmitAdd = async () => {
    if (handleValid()) {
      try {
        setSubmitLoading(true);
        const res = await addBlogcategory(formData);
        if (res.code === 200) {
          toast.success(res.message);
          blockcategories(); // Refresh the list
          parentblocks();
          setAddModal(false);
          setFormData({ title: "", description: "", parentcategoryid: "" });
          setErrors({});

        } else {
          toast.error(res.message);
          setFormData({ title: "", description: "", parentcategoryid: "" });
          setErrors({});
          parentblocks();

        }
      } catch (err) {
        toast.error(err.message);
      } finally {
        setSubmitLoading(false);
      }
    } else {
      toast.error("Please input all fields")
    }

  };

  const handleSubmitUpdate = async () => {
    if (handleValid()) {
      try {
        setSubmitLoading(true);
        const res = await UpdateBlogcategory({
          ...formData,
          categoryid: selectedData.categoryid,
        });
        if (res.code === 200) {
          toast.success(res.message);
          blockcategories(); // refresh list
          setUpdateModal(false);
          setSelectedData({});
          setFormData({ title: "", description: "", parentcategoryid: "" });
          setErrors({});
        } else {
          toast.error(res.message);
        }
      } catch (err) {
        toast.error(err.message);
      } finally {
        setSubmitLoading(false);
      }
    } else {
      toast.error("Please input all fields");
    }
  };


  // open link modal function
  const openLinkModalHandler = (data) => {
    setLinkSelectedId(data.id);
    setAssignStatus({
      course: data.isAssignedCourse,
      faq: data.isAssignedFaq,
      video: data.isAssignedVideo,
      image: data.isAssignedImage,
    });
    setGalleryImage(data.centerImage);
    setLinkModal(true);
  };

  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };

  //********Reset Filter****** */
  const restFilter = () => {
    setSearch("");
  };

  useEffect(() => {
    if (debounceValue) {
      searchParam.set("query", debounceValue);
    } else {
      searchParam.delete("query");
    }
    if (activePage === 1) {
      searchParam.delete("page");
    }
    setSearchParam(searchParam);
    blockcategories(activePage, debounceValue);
    parentblocks()
    // eslint-disable-next-line
  }, [searchParam, debounceValue]);

  useEffect(() => {
    if (search) {
      searchParam.set("page", "");
    }
    // eslint-disable-next-line
  }, [search]);

  return (
    <React.Fragment>
      <title>Shubhra Viraj | Blog Category Management</title>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <div className="SearchBox">
                <div className="div_wrap">
                  <input
                    type="text"
                    placeholder="Search"
                    name="search"
                    className="form-control"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>

                <Button className="refresh_btnn mx-2" onClick={restFilter}>
                  <i className="fa fa-refresh"></i>
                </Button>
                <div>
                  <Button
                    onClick={() => setAddModal(true)}
                    type="acl"
                    role={450002}
                  >
                    Create Blog Category
                  </Button>
                </div>
              </div>
              <h4 className="Title">Blog Categories</h4>
            </div>
            <div className="TableList overflow-auto table-responsive">
              {loader}
              <Table bordered className="table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Category Title</th>
                    <th>Description</th>
                    <th>Parent Category</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {record && record.length > 0 ? (
                    record.map(
                      (
                        {
                          categoryid,
                          title,
                          description,
                          parentcategoryid,
                          parentcategory,
                          status,
                        },
                        i
                      ) => (
                        <tr key={i}>
                          <td>{++i + (activePage - 1) * 10}</td>
                          <td>
                            <Tooltip title={title}>
                              <div className="">{title}</div>
                            </Tooltip>
                          </td>

                          <td>{description}</td>
                          <td>{parentcategory}</td>



                          <td>
                            <Switch
                              checked={status}
                              onChange={() => {
                                setSelectedId(categoryid);
                                setSelectedStatus(status);
                                setBlockModal(true);
                              }}
                              type="acl"
                              role={450003}
                            />
                          </td>

                          <td>
                            <div className="d-flex justify-content-center">
                              <IconButton
                                aria-label="view"
                                className="px-2 py-0"
                                onClick={() => {
                                  setSelectedData({
                                    categoryid,
                                    title,
                                    description,
                                    parentcategory: parentcategory,
                                    parentcategoryid: parentcategoryid || "", // Set the parentcategoryid properly
                                  });
                                  setFormData({
                                    title: title || "",
                                    description: description || "",
                                    parentcategoryid: parentcategoryid || "", // Important to pre-fill dropdown
                                  });
                                  setUpdateModal(true);
                                }}

                                type="acl"
                                role={450004}
                              >
                                <EditIcon sx={{ color: "#4971B2" }} />
                              </IconButton>
                            </div>
                          </td>
                        </tr>
                      )
                    )
                  ) : (
                    <NotFound cols={12} />
                  )}
                </tbody>
              </Table>
            </div>
            {total > 10 ? (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={10}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>

      {/* block or unblock model */}
      <ModalBox
        status={blockModal}
        onClose={() => setBlockModal(false)}
        title={"Change Status"}
        description={"You want to change status of this centre?"}
        customizedFooter={
          <Button onClick={updateStatusHandler} {...submitButtonElement}>
            Yes
          </Button>
        }
      />

      <ModalBox
        status={addModal}
        onClose={() => {
          setAddModal(false);
          setErrors({});
          setFormData({ title: "", description: "", parentcategoryid: "" });
        }}
        title="Add Blog Category"
        customizedFooter={
          <Button
            onClick={handleSubmitAdd} {...submitButtonElement}>
            Add Category
          </Button>
        }
      >
        <div className="form-group mb-3">
          <label>Title</label>
          <input
            type="text"
            name="title"
            className={`form-control ${errors.title ? 'is-invalid' : ''}`}
            value={formData.title}
            onChange={handleInputChange}
            placeholder="Enter title"
          />
          {errors.title && <div className="invalid-feedback">{errors.title}</div>}
        </div>

        <div className="form-group mb-3">
          <label>Description</label>
          <textarea
            name="description"
            className={`form-control ${errors.description ? 'is-invalid' : ''}`}
            value={formData.description}
            onChange={handleInputChange}
            placeholder="Enter description"
          />
          {errors.description && (
            <div className="invalid-feedback">{errors.description}</div>
          )}
        </div>


        <div className="form-group mb-3">
          <label>Parent Category</label>
          <select
            name="parentcategoryid"
            className="form-control"
            value={formData.parentcategoryid}
            onChange={handleInputChange}
          >
            <option value="">Select Parent Category</option>
            {parentblockarray.map((cat) => (
              <option key={cat.categoryid} value={cat.categoryid}>
                {cat.title}
              </option>
            ))}
          </select>
        </div>
      </ModalBox>

      <ModalBox
        status={updateModal}
        onClose={() => {
          setUpdateModal(false);
          setErrors({});
          setFormData({ title: "", description: "", parentcategoryid: "" });
        }}
        title="Update Blog Category"
        customizedFooter={
          <Button onClick={handleSubmitUpdate} {...submitButtonElement}>
            Update Category
          </Button>
        }
      >
        <div className="form-group mb-3">
          <label>Title</label>
          <input
            type="text"
            name="title"
            className={`form-control ${errors.title ? "is-invalid" : ""}`}
            value={formData.title}
            onChange={handleInputChange}
            placeholder="Enter title..."
          />
          {errors.title && <div className="invalid-feedback">{errors.title}</div>}
        </div>

        <div className="form-group mb-3">
          <label>Description</label>
          <textarea
            name="description"
            className={`form-control ${errors.description ? "is-invalid" : ""}`}
            value={formData.description}
            onChange={handleInputChange}
            placeholder="Enter description..."
          />
          {errors.description && (
            <div className="invalid-feedback">{errors.description}</div>
          )}
        </div>

        <div className="form-group mb-3">
          <label>Parent Category</label>
          <select
            name="parentcategoryid"
            value={formData.parentcategoryid || ""}
            onChange={handleInputChange}
            className="form-control"
          >
            {formData.parentcategoryid ? null : (
              <option value="">Select Parent Category</option>
            )}

            {parentblockarray.map((item) => (
              <option key={item.categoryid} value={item.categoryid}>
                {item.title}
              </option>
            ))}
          </select>



        </div>
      </ModalBox>





    </React.Fragment>
  );
};

export default BlogCategory;
